import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';

const ChannelRepository = RepositoryFactory.get('channel') as Repositories['channel'];

export const useChannel = () => {
  /**
   * Channel取得
   * @param channelId
   */
  const get = async (channelId: string) => {
    return await ChannelRepository.get(channelId);
  };

  return {
    get,
  };
};

type ChannelType = ReturnType<typeof useChannel>;
export const ChannelKey: InjectionKey<ChannelType> = Symbol('Channel');
